import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useChatTranscriptQuery } from "@/modules/patients/detail/progress-note/hooks/__generated__/useChatTranscriptQuery.graphql"

export const chatTranscriptQueryById = graphql`
  query useChatTranscriptQuery($id: ID!) {
    appointmentById(id: $id) {
      chatTranscript
      chatDetails {
        chatThreadId
      }
    }
  }
`

const useChatTranscriptByAppointmentId = (id: string) => {
  const data = useLazyLoadQuery<useChatTranscriptQuery>(chatTranscriptQueryById, {
    id,
  })

  return data
}

export { useChatTranscriptByAppointmentId }
